////////////////////////
// M027 content navigation

function initContentNavigation() {
    if ($(".contentNavigation").length > 0) {

        $(".contentNavigation").each(function () {
            $(this).find(".contentNavigationSelectBox").find("select").on("change", function (e) {
                var value = $(this).val();
                window.location.href = value;
            });
        });
    }
}

function initContentNavigationTabs() {

    consolog("initContentNavigationTabs()");
    
    if ($(".contentNavigationTabs").length > 0) {
        
        $(".contentNavigationTabs").each(function(){
            
            consolog("initContentNavigationTabs() " + $(this).find("span").html() + " / height:" + $(this).height() + " / first-height:" +  $(this).children(".contentNavigationTab").first().height());

            //tabs break to second row?
            if($(this).height() > ($(this).children(".contentNavigationTab").first().height() + 10)){

                //set active index
                var initIndex = 0;
                if($(this).find(".contentNavigationTab.active").length > 0){
                    initIndex = $(this).find(".contentNavigationTab.active").index();                    
                }
                else{
                    $(this).addClass("firstactive");
                }

                //start slick slider
                $(".contentNavigationTabs").slick({
                    slidesToScroll:1,
                    infinite: true,
                    dots: false,
                    prevArrow: slickPrevArrowCode,
                    nextArrow: slickNextArrowCode,
                    adaptiveHeight: false,
                    variableWidth: true,
                    initialSlide: initIndex
                });
                
                //change handler
                $('.contentNavigationTabs').on('beforeChange', function (event, slick, currentSlide) {
                    $(this).removeClass("firstactive");
                });
                $('.contentNavigationTabs').on('afterChange', function (event, slick, currentSlide) {
                    $(this).removeClass("firstactive");
                    $(this).removeClass("lastactive");
                    var currentSlide = $(this).slick('slickCurrentSlide');
                    var slideCount = $(this).slick('getSlick').slideCount;
                    if (currentSlide == 0) {
                        $(this).addClass("firstactive");
                    }
                    if (currentSlide == slideCount) {
                        $(this).addClass("lastactive");
                    }
                });
            }
        });
    }
}

function updateContentNavigationTabs(){
/*
    if ($(".contentNavigationTabs").length > 0 && $(".contentNavigationTabs").hasClass("slick-initialized")) {

        $(".contentNavigationTabs").slick("slickSetOption", "slidesToShow", 1, false);
        $(".contentNavigationTabs").slick("slickSetOption", "infinite", false, false);

        var w = 0;
        var c = 0;
        $(".contentNavigationTabs").children(".contentNavigationTab").each(function(){
            c++;
            w += $(this).width();
        });

        consolog("updateContentNavigationTabs() # w:" + w + " # c:" + c);

        if(w > $(".contentNavigationTabs").width()){
            consolog("updateContentNavigationTabs() v1");
            $(".contentNavigationTabs").slick("slickSetOption", "slidesToShow", 1, false);
            $(".contentNavigationTabs").slick("slickSetOption", "infinite", true, false);
        }
        else{
            consolog("updateContentNavigationTabs() v2");
            $(".contentNavigationTabs").slick("slickSetOption", "slidesToShow", c, false);
            $(".contentNavigationTabs").slick("slickSetOption", "infinite", false, false);
        }
    }
*/
}